import monthSelectPlugin from  'flatpickr/dist/plugins/monthSelect/index.js'


'use strict';

(function() {

  //
  // Variables
  //

  var toggle = document.querySelectorAll('[data-toggle="expected_intake_year_flatpickr"]');


  //
  // Functions
  //

  function init(el) {
    var options = {
      minDate: "today",
      dateFormat: "F Y",
      plugins: [
        new monthSelectPlugin({
          shorthand: true, //defaults to false
        })
      ]
    };

    flatpickr(el, options);
  }


  //
  // Events
  //

  if (typeof flatpickr !== 'undefined' && toggle) {
    [].forEach.call(toggle, function(el) {
      init(el);
    });
  }

})();